const FULL_WIDTH = 1
const NO_WIDTH = 0

export enum KeyType {
  Regular = 'regular',
  Remaining = 'remaining',
  Overtime = 'overtime',
  BlankSlate = 'blankSlate',
}

// We need the HEX color code for the Nivo Bar fillings
const keyColorMap = {
  [KeyType.Regular]: '#07A2AD', // viridian1000
  [KeyType.Remaining]: '#E2E2E5', // grey400
  [KeyType.Overtime]: '#FF9153', // tangerine1000
  [KeyType.BlankSlate]: '#E9ECEF', // grey300,
}

export const keys = Object.keys(keyColorMap)
export const colors = Object.values(keyColorMap)

type Data = {
  [key in KeyType]: number
}

export const generateData = (
  estimatedMinutes: number,
  regular: number,
  overtime: number,
  remaining: number
): Data[] => {
  if (estimatedMinutes === 0 && regular === 0 && overtime === 0) {
    return [
      {
        regular: NO_WIDTH,
        remaining: NO_WIDTH,
        overtime: NO_WIDTH,
        blankSlate: FULL_WIDTH,
      },
    ]
  }

  if (estimatedMinutes === 0 && regular > 0) {
    return [
      {
        regular: FULL_WIDTH,
        remaining: NO_WIDTH,
        overtime: NO_WIDTH,
        blankSlate: NO_WIDTH,
      },
    ]
  }

  return [
    {
      regular: regular || NO_WIDTH,
      remaining: remaining || NO_WIDTH,
      overtime: overtime || NO_WIDTH,
      blankSlate: NO_WIDTH,
    },
  ]
}
